/**
 * A1 — Encabezado de agenda estilo Booksy: «Hoy · Dom 18 oct ⌄» (o «Mar 27 oct ⌄» + botón «Hoy»),
 * horario del día debajo; tocarlo despliega el calendario del mes.
 */
import { ChevronDown } from 'lucide-react';
import { formatDateShortEs, formatTime12 } from '@/utils/bookingFormat';
import { tr } from '@/contexts/LanguageContext';

const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

export const AgendaDateHeader = ({ selected, today, hours, open, onToggle, onToday, children }) => {
  const isToday = selected === today;
  const hoursText = hours === undefined ? null : hours === 'closed' ? tr("Cerrado") : hours ? `${formatTime12(hours.start)} – ${formatTime12(hours.end)}` : null;
  return (
    <div className="flex items-start justify-between gap-2" data-testid="agenda-date-header">
      <div className="min-w-0">
        <button type="button" onClick={onToggle} aria-expanded={open} className="flex items-center gap-1 text-left" data-testid="agenda-date-toggle">
          <span className="font-display text-lg font-bold text-primary leading-tight" data-testid="agenda-date-title">
            {isToday ? `${tr("Hoy")} · ` : ''}{cap(formatDateShortEs(selected))}
          </span>
          <ChevronDown className={`w-4 h-4 text-primary transition-transform ${open ? 'rotate-180' : ''}`} />
        </button>
        {hoursText && <p className="text-xs text-muted-foreground tabular-nums" data-testid="agenda-date-hours">{hoursText}</p>}
      </div>
      <div className="flex items-center gap-2 shrink-0">
        {!isToday && (
          <button type="button" onClick={onToday} className="text-[11px] font-semibold px-2.5 py-1 rounded-full border border-primary/50 text-primary hover:bg-primary/10" data-testid="agenda-date-today">
            {tr("Hoy")}
          </button>
        )}
        {children}
      </div>
    </div>
  );
};

export default AgendaDateHeader;
